export default function PHP_error_list() {
  return (
    <div>
      <h1>PHP_error_list</h1>
    </div>
  );
}
